import React from 'react';
import PropTypes from 'prop-types';

import { Grid, Row } from '@sm/wds-react';
import AppCard from '../AppCard';

import './apps-grid.scss';

const AppsGrid = ({ apps = [] }) => (
  <Grid noBleeds className="sm-apps-grid__apps wds-m-t-3" data-testid="AppsGrid__Grid">
    <Row>
      {apps.map(app => (
        <AppCard key={app.id} app={app} />
      ))}
    </Row>
  </Grid>
);

AppsGrid.propTypes = {
  apps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      logo: PropTypes.string.isRequired,
      links: PropTypes.shape({
        detail: PropTypes.string.isRequired,
      }),
      categories: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
        }).isRequired
      ),
    })
  ).isRequired,
};

export default AppsGrid;
